import {
  CurrentLanguage,
  LanguageSelectorContainer,
  LanguageSelectorDrawer,
  LanguageSelectorItem,
  LanguageSpeedDial,
  FlagIcon,
} from "./styles";
import { Button } from "primereact/button";
import { Link, useI18next } from "gatsby-plugin-react-i18next";
import { AiOutlineCaretDown } from "react-icons/ai";
import { useCallback } from "react";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import BgFlagIcon from "images/bulgaria_round_concave_icon_64.png";
import EnFlagIcon from "images/united_kingdom_round_concave_icon_64.png";
import DeFlagIcon from "images/germany_round_concave_icon_64.png";

const LANG_LABEL_MAP = {
  en: {
    label: "English",
    icon: EnFlagIcon,
  },
  bg: {
    label: "Български",
    icon: BgFlagIcon,
  },
  de: {
    label: "Deutsch",
    icon: DeFlagIcon,
  },
};

const LanguageSelector = () => {
  const { originalPath, language: currentLanguage, languages } = useI18next();

  return (
    <LanguageSpeedDial
      model={languages.map((language) => ({
        label: language,
        visible: language !== currentLanguage,
        template: ({ visible }) => {
          if (!visible) {
            return null;
          }

          return (
            <Link
              activeClassName="link-active"
              role="menuitem"
              key={language}
              to={originalPath.replace(currentLanguage, language)}
              language={language}
            >
              <Button className="p-button-outlined" style={{ color: "white" }}>
                {LANG_LABEL_MAP[language]}
              </Button>
            </Link>
          );
        },
      }))}
      direction="down"
      buttonTemplate={(props) => (
        <Button
          className="p-button-text"
          onClick={props.onClick}
          icon={
            <span>
              <AiOutlineCaretDown />
            </span>
          }
        >
          {LANG_LABEL_MAP[currentLanguage]}
        </Button>
      )}
    />
  );
};

export const BetterLanguageSelector = () => {
  const {
    originalPath,
    language: currentLanguageKey,
    languages,
  } = useI18next();
  const [shouldShowDrawer, setShouldShowDrawer] = useState(false);
  const currentLanguage = LANG_LABEL_MAP[currentLanguageKey];
  let timer = useRef();

  const handleMouseEnter = useCallback(() => {
    setShouldShowDrawer(true);
    clearTimeout(timer.current);
  }, []);

  const handleMouseLeave = useCallback(() => {
    timer.current = setTimeout(() => {
      setShouldShowDrawer(false);
    }, 1000);
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  });

  return (
    <LanguageSelectorContainer
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CurrentLanguage>
        <FlagIcon
          src={currentLanguage.icon}
          alt={`${currentLanguage.label} flag icon`}
        />
        <span>{currentLanguage.label}</span>
        <span>
          <AiOutlineCaretDown size={14} />
        </span>
      </CurrentLanguage>
      <LanguageSelectorDrawer shouldShow={shouldShowDrawer}>
        {languages
          .map((languageKey, index) => {
            const { label, icon } = LANG_LABEL_MAP[languageKey];

            return (
              languageKey !== currentLanguageKey && (
                <li key={languageKey}>
                  <LanguageSelectorItem
                    role="menuitem"
                    key={languageKey}
                    to={originalPath.replace(currentLanguageKey, languageKey)}
                    language={languageKey}
                  >
                    <FlagIcon src={icon} alt={`${label} flag icon`} />
                    <span>{label}</span>
                  </LanguageSelectorItem>
                </li>
              )
            );
          })
          .filter(Boolean)}
      </LanguageSelectorDrawer>
    </LanguageSelectorContainer>
  );
};

export default LanguageSelector;
